import React from "react";

const PlayVideo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity="0.6" cx="36" cy="36" r="34" fill="black" />
    <path
      d="M28.9944 22.882C28.9944 22.0819 29.8873 21.6058 30.5516 22.0517L49.9462 35.0673C50.5365 35.4635 50.5365 36.3318 49.9462 36.728L30.5516 49.7435C29.8872 50.1894 28.9944 49.7133 28.9944 48.9132L28.9944 35.8976L28.9944 22.882Z"
      fill="white"
    />
  </svg>
);

export default PlayVideo;
